module.exports = __webpack_public_path__ + "static/pic05.be7e637c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic05.jpg
// module id = 531
// module chunks = 35783957827783